import React from 'react'

export const appointmentFormInputClass =
  'w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 disabled:opacity-60'

export const appointmentFormLabelClass =
  'block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1'

export function AppointmentFormSection({
  step,
  title,
  description,
  action,
  children,
}: {
  step?: number
  title: string
  description?: string
  /** Conteúdo à direita do título (ex.: botão Ver disponibilidade). */
  action?: React.ReactNode
  children: React.ReactNode
}) {
  return (
    <section className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900/40 p-4 space-y-3">
      <div className="flex items-start gap-3">
        {typeof step === 'number' ? (
          <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-600 text-xs font-semibold text-white">
            {step}
          </span>
        ) : null}
        <div className="min-w-0 flex-1 flex items-start justify-between gap-3">
          <div className="min-w-0">
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white">{title}</h3>
            {description ? (
              <p className="mt-0.5 text-xs text-gray-500 dark:text-gray-400">{description}</p>
            ) : null}
          </div>
          {action ? <div className="shrink-0">{action}</div> : null}
        </div>
      </div>
      {children}
    </section>
  )
}

export function AppointmentCreatedSummary({
  rows,
}: {
  rows: Array<{ label: string; value: string; wide?: boolean; href?: string }>
}) {
  return (
    <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-3 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900/40 p-4">
      {rows.map((row) => {
        const text = row.value.trim()
        const href = row.href?.trim()
        return (
          <div key={row.label} className={row.wide ? 'sm:col-span-2' : undefined}>
            <dt className="text-xs text-gray-500 dark:text-gray-400">{row.label}</dt>
            <dd className="mt-0.5 text-sm text-gray-900 dark:text-white break-words">
              {href && text ? (
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary-700 underline hover:text-primary-800 dark:text-primary-300 dark:hover:text-primary-200"
                >
                  {text}
                </a>
              ) : (
                text || '—'
              )}
            </dd>
          </div>
        )
      })}
    </dl>
  )
}

export function AppointmentFormField({
  label,
  required,
  hint,
  children,
  className = '',
}: {
  label: string
  required?: boolean
  hint?: React.ReactNode
  children: React.ReactNode
  className?: string
}) {
  return (
    <div className={className}>
      <label className={appointmentFormLabelClass}>
        {label}
        {required ? <span className="text-red-500"> *</span> : null}
      </label>
      {children}
      {hint}
    </div>
  )
}
